// Simple localStorage-backed notification service
// Shape: { id, title, body, ts, read }

const LS_KEY = 'tts.notifications.v1';
let listeners = new Set();

function load(){
  try {
    const raw = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
    if(Array.isArray(raw)) return raw;
  } catch(e){ /* ignore */ }
  return [];
}

function save(list){
  localStorage.setItem(LS_KEY, JSON.stringify(list));
  listeners.forEach(l=> l(list));
}

export function subscribe(fn){
  listeners.add(fn);
  fn(load());
  return ()=> listeners.delete(fn);
}

export function list(){
  return load().sort((a,b)=> b.ts - a.ts);
}

export function add({ title, body }){
  const items = load();
  const id = crypto.randomUUID();
  const ts = Date.now();
  items.push({ id, title, body, ts, read:false });
  save(items);
  return id;
}

export function markRead(id){
  const items = load();
  const idx = items.findIndex(n=> n.id === id);
  if(idx !== -1){ items[idx].read = true; save(items); }
}

export function markAllRead(){
  const items = load();
  let changed = false;
  for(const n of items){ if(!n.read){ n.read = true; changed = true; } }
  if(changed) save(items);
}

// Seed some demo notifications if empty
(function seed(){
  const existing = load();
  if(!existing.length){
    save([
      { id: crypto.randomUUID(), title:'Scan Completed', body:'Latest Trust Tech Scan finished with 82% integrity score.', ts: Date.now()-1000*60*5, read:false },
      { id: crypto.randomUUID(), title:'Report Ready', body:'Quarterly ESG alignment report is now available.', ts: Date.now()-1000*60*60, read:false },
      { id: crypto.randomUUID(), title:'Policy Update', body:'New adaptive governance policy suggestions generated.', ts: Date.now()-1000*60*90, read:true }
    ]);
  }
})();
